import { API } from '../../constants/api'

const axiosConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  timeout: API.TIMEOUT,
}

export default axiosConfig
